import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{this.tagRecord.id}}",{ moduleName: "discourse/components/discourse-tag-bound.hbs" })